module.exports = __webpack_public_path__ + "static/media/UAI.513f6179.png";